import { Button, Flex, Link, Text, VStack } from '@chakra-ui/react';

import { ArrowLeftOutline } from '@aslanpay/portal-common-lib';

import { AuthenticationStepProps } from '../types';

function InvalidEmail({ onSetStep }: AuthenticationStepProps) {
  return (
    <Flex flexDir="column" mt="35px">
      <Button
        alignSelf="flex-start"
        size="sm"
        variant="link"
        leftIcon={<ArrowLeftOutline boxSize="20px" />}
        onClick={() => onSetStep('checkEmail')}
      >
        Back
      </Button>
      <Text as="h2" textStyle="h2" color="brand.darkPurple" mt="25px">
        Oops, invalid email
      </Text>
      <Text as="h5" textStyle="h5Medium" color="brand.mutedPurple" mt="15px" mb="35px">
        It seems the email you&apos;ve entered doesn&apos;t match our records. Please double-check
        your email address or reach out to our support team for assistance.
      </Text>
      <VStack spacing={0}>
        <Text textStyle="smallRegular" color="brand.darkGray">
          Having issues?
        </Text>
        <Link
          href="mailto:support@aslan.io"
          target="_blank"
          color="brand.purple"
          textStyle="smallMedium"
          textDecoration="underline"
        >
          Please contact support
        </Link>
      </VStack>
    </Flex>
  );
}

export default InvalidEmail;
